import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirm-action" }
const _hoisted_2 = { class: "confirm-action__title" }
const _hoisted_3 = { class: "confirm-action__description" }
const _hoisted_4 = { class: "confirm-action__actions" }

import AppButton from "@/components/ui-kit/button/AppButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmActionDropdown',
  props: {
    title: { default: 'Подтвердите действие' },
    description: { default: '' },
    cancelLabel: { default: 'Отмена' },
    confirmLabel: { default: 'Подтвердить' }
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.description), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(AppButton, {
        class: "confirm-action__actions-button",
        type: "secondary",
        label: _ctx.cancelLabel,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, null, 8, ["label"]),
      _createVNode(AppButton, {
        class: "confirm-action__actions-button",
        label: _ctx.confirmLabel,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, null, 8, ["label"])
    ])
  ]))
}
}

})